<template>
  <el-dialog
      v-loading="false"
      :fullscreen="false"
      :close-on-press-escape="true"
      :show-close="false"
      :close-on-click-modal="false"
      class="exit-dialog"
      :visible.sync="visible">
    <div class="exit-modal-header">
      <div class="exit-modal-header-text">
        Replacements
      </div>
      <button
          type="button"
          class="el-dialog__headerbtn"
          aria-label="Close"
          @click="$emit('update:visible', false)">
        <i class="el-dialog__close el-icon el-icon-close"></i>
      </button>
    </div>
    <div style="border: 1px solid #DEE5EC;"></div>

    <div class="exit-modal-body">
      <div class="warning-img">
        <img
            src="../../assets/warning-icon.svg"
            style="height: 48px; width: 100%; padding: 6px 0px 6px 4px;">
      </div>
      <div
          class="exit-modal-title"
          style="padding: 0px !important;">
        Exit the flow?
      </div>
      <div
          class="exit-modal-description"
          style="padding: 0px !important;">
        If you do this, you’ll need to start over.
      </div>
    </div>

    <div style="padding: 16px 40px 24px 40px;">
      <div
          class="flex flex-row exit-modal-buttons">
        <div style="width: 100%;">
          <el-button
              class="cancel-button"
              aria-label="Close"
              @click="$emit('update:visible', false)">
            Cancel
          </el-button>
        </div>
        <div style="width: 100%;">
          <el-button
              class="exit-button"
              @click="exitReplacement">
            Exit
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "ExitModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    exitReplacement() {
      this.$emit("exit-replacement", true);
    },
  },
};
</script>

<style>
.exit-dialog {
  .exit-modal-header {
    /* Modal Header */
    width: 100%;
    height: 56px;
    background: #ffffff;
    border-radius: 4px 4px 0px 0px;
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;

    .exit-modal-header-text {
      position: absolute;
      width: 100px;
      height: 24px;
      left: calc(50% - 86px / 2);
      top: 16px;
      font-family: "Equip";
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
      text-align: center;
      color: #424242;
    }
  }

  .exit-modal-body {
    padding-right: 40px;
    padding-left: 40px;
    position: relative;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    height: 172px;
    background: #ffffff;

    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;

    .warning-img {
      margin-top: 24px;
      flex-direction: column;
      align-self: flex-start;
      display: flex;
      flex: none;
      order: 0;
      flex-grow: 0;
    }

    .exit-modal-title {
      margin-top: 8px;
      margin-bottom: 8px;
      height: 36px;
      font-family: "Equip";
      font-style: normal;
      font-weight: 500;
      font-size: 24px;
      line-height: 36px;
      color: #424242;
    }

    .exit-modal-description {
      margin-bottom: 24px;
      height: 24px;
      font-family: "Equip";
      font-style: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 1.5;
      overflow-wrap: break-word;
      color: #424242;
    }
  }

  .exit-modal-buttons {
    .cancel-button {
      height: 48px;
      margin-right: 16px !important;
      box-sizing: border-box;
      background: #ffffff;
      border: 1px solid #1998d5;
      border-radius: 8px;
      flex: none;
      order: 0;
      flex-grow: 1;
      justify-content: center;
      color: #1998d5;
      align-items: center;
      text-align: center;
      overflow-y: scroll;
      width: 100%;
      flex: none;
      flex-grow: 1;
    }

    .exit-button {
      height: 48px;
      margin-left: 16px !important;
      background: #1998d5;
      border-radius: 8px;
      flex: none;
      order: 1;
      flex-grow: 1;
      overflow-y: scroll;
      font-style: normal;
      font-weight: 700;
      font-size: 18px;
      line-height: 28px;
      display: flex;
      align-items: center;
      text-align: center;
      color: #ffffff;
      justify-content: center;
      width: 100%;
      flex: none;
      flex-grow: 1;
    }
  }
}
</style>
